/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

import React from "react";

// Lazy-loaded module components
const WorkSheet = React.lazy(() => import("modules/worksheet"));
const Workreports = React.lazy(() => import("modules/workreports"));
const ProjectsOverview = React.lazy(() => import("modules/projectsOverview"));
const MaterialOverview = React.lazy(() => import("modules/materialOverview"));
const CustomerOverview = React.lazy(() => import("modules/customerOverview"));
const EmployeeOverview = React.lazy(() => import("modules/employeeOverview"));
const RentalEquipment = React.lazy(() => import("modules/rentalEquipment"));
const Calendar = React.lazy(() => import("modules/calendar"));

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "title",
    key: "title0",
    title: "Mitarbeiter",
    allowedRoles: ["team"],
  },
  {
    type: "collapse",
    name: "Arbeitserfassung",
    key: "worksheet",
    icon: <Icon fontSize="small">manage_accounts</Icon>,
    route: "/worksheet",
    component: <WorkSheet />,
    allowedRoles: ["team"],
  },
  {
    type: "divider",
    key: "divider1",
    allowedRoles: ["team"],
  },
  {
    type: "title",
    key: "title1",
    title: "Übersicht",
    allowedRoles: ["team"],
  },

  
 /* {
    type: "collapse",
    name: "dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },  */
  {
    type: "collapse",
    name: "Workreports",
    key: "tables",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/workreports",
    component: <Workreports />,
    allowedRoles: ["whitelist-support","team"],
  },
  {
    type: "collapse",
    name: "Projekte",
    key: "projects",
    icon: <Icon fontSize="small">assignment_turned_in</Icon>,
    route: "/projects",
    component: <ProjectsOverview />,
    allowedRoles: ["whitelist-support","team"],
  },
  {
    type: "collapse",
    name: "Materialien",
    key: "materials",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/materials",
    component: <MaterialOverview />,
    allowedRoles: ["whitelist-support","team"],
  },
  {
    type: "collapse",
    name: "Kunden",
    key: "customers",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/customers",
    component: <CustomerOverview />,
    allowedRoles: ["whitelist-support","team"],
  },
  {
    type: "collapse",
    name: "Mitarbeiter",
    key: "employees",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/employees",
    component: <EmployeeOverview />,
    allowedRoles: ["whitelist-support","team"],
  },
  {
    type: "title",
    key: "title2",
    title: "Weitere Module",
    allowedRoles: ["team"],
  },
  {
    type: "collapse",
    name: "Mietgeräte",
    key: "rental-equipment",
    icon: <Icon fontSize="small">construction</Icon>,
    route: "/rental-equipment",
    component: <RentalEquipment />,
    allowedRoles: ["whitelist-support","team"],
  },
  {
    type: "collapse",
    name: "Kalender",
    key: "kalender",
    icon: <Icon fontSize="small">calendar_month</Icon>,
    route: "/kalender",
    component: <Calendar />,
    allowedRoles: ["team", "admin", "manager", "superuser", "whitelist-support", "chef"],
  },
  /* {
    type: "collapse",
    name: "Exports",
    key: "exports",
    icon: <QueryStatsIcon/>,
    route: "/tables",
    component: <Workreports />,
    allowedRoles: ["whitelist-support","team"],
  }, */
 /*  {
    type: "divider",
    key: "divider2",
    allowedRoles: ["team"],
  },
  {
    type: "title",
    key: "title2",
    title: "Externe Links/Tools",
    allowedRoles: ["team"],
  },
  {
    type: "collapse",
    name: "Analyse",
    key: "grafana",
    icon: <QueryStatsIcon/>,
    href: "https://dietrich-development.de",
    target: "_blank",
    allowedRoles: ["team"],
  },
  {
    type: "collapse",
    name: "Rechnungen",
    key: "teamwiki",
    icon: <Icon fontSize="small">table_view</Icon>,
    href: "https://dietrich-development.de",
    target: "_blank",
    allowedRoles: ["team"],
  }, */
  
];

export default routes;



export function filterRoutesByRole(routes, userRoles) {
  return routes
    .filter(route => {
      // Check for excludedRoles and if any of them are in userRoles
      if (route.excludedRoles && route.excludedRoles.some(role => userRoles.includes(role))) {
        return false;
      }

      // Check for allowedRoles and if any of them are in userRoles
      if (route.allowedRoles) {
        return route.allowedRoles.some(role => userRoles.includes(role));
      }
      return true;
    })
    .map(route => {
      if (route.collapse) {
        return {
          ...route,
          collapse: filterRoutesByRole(route.collapse, userRoles),
        };
      }
      return route;
    });
}




